function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

import { Alias } from '../nodes/Alias.js';
import { isEmptyPath, collectionFromPath } from '../nodes/Collection.js';
import { NODE_TYPE, DOC, isNode, isCollection, isScalar } from '../nodes/identity.js';
import { Pair } from '../nodes/Pair.js';
import { toJS as _toJS } from '../nodes/toJS.js';
import { Schema } from '../schema/Schema.js';
import { stringifyDocument } from '../stringify/stringifyDocument.js';
import { anchorNames, findNewAnchor, createNodeAnchors } from './anchors.js';
import { applyReviver } from './applyReviver.js';
import { createNode as _createNode } from './createNode.js';
import { Directives } from './directives.js';

var Document = /*#__PURE__*/function () {
  function Document(value, replacer, options) {
    var _options;

    _classCallCheck(this, Document);

    /** A comment before this Document */
    this.commentBefore = null;
    /** A comment immediately after this Document */

    this.comment = null;
    /** Errors encountered during parsing. */

    this.errors = [];
    /** Warnings encountered during parsing. */

    this.warnings = [];
    Object.defineProperty(this, NODE_TYPE, {
      value: DOC
    });
    var _replacer = null;

    if (typeof replacer === 'function' || Array.isArray(replacer)) {
      _replacer = replacer;
    } else if (options === undefined && replacer) {
      options = replacer;
      replacer = undefined;
    }

    var opt = Object.assign({
      intAsBigInt: false,
      keepSourceTokens: false,
      logLevel: 'warn',
      prettyErrors: true,
      strict: true,
      stringKeys: false,
      uniqueKeys: true,
      version: '1.2'
    }, options);
    this.options = opt;
    var version = opt.version;

    if ((_options = options) !== null && _options !== void 0 && _options._directives) {
      this.directives = options._directives.atDocument();
      if (this.directives.yaml.explicit) version = this.directives.yaml.version;
    } else this.directives = new Directives({
      version: version
    });

    this.setSchema(version, options); // @ts-expect-error We can't really know that this matches Contents.

    this.contents = value === undefined ? null : this.createNode(value, _replacer, options);
  }
  /**
   * Create a deep copy of this Document and its contents.
   *
   * Custom Node values that inherit from `Object` still refer to their original instances.
   */


  _createClass(Document, [{
    key: "clone",
    value: function clone() {
      var copy = Object.create(Document.prototype, _defineProperty({}, NODE_TYPE, {
        value: DOC
      }));
      copy.commentBefore = this.commentBefore;
      copy.comment = this.comment;
      copy.errors = this.errors.slice();
      copy.warnings = this.warnings.slice();
      copy.options = Object.assign({}, this.options);
      if (this.directives) copy.directives = this.directives.clone();
      copy.schema = this.schema.clone(); // @ts-expect-error We can't really know that this matches Contents.

      copy.contents = isNode(this.contents) ? this.contents.clone(copy.schema) : this.contents;
      if (this.range) copy.range = this.range.slice();
      return copy;
    }
    /** Adds a value to the document. */

  }, {
    key: "add",
    value: function add(value) {
      if (assertCollection(this.contents)) this.contents.add(value);
    }
    /** Adds a value to the document. */

  }, {
    key: "addIn",
    value: function addIn(path, value) {
      if (assertCollection(this.contents)) this.contents.addIn(path, value);
    }
    /**
     * Create a new `Alias` node, ensuring that the target `node` has the required anchor.
     *
     * If `node` already has an anchor, `name` is ignored.
     * Otherwise, the `node.anchor` value will be set to `name`,
     * or if an anchor with that name is already present in the document,
     * `name` will be used as a prefix for a new unique anchor.
     * If `name` is undefined, the generated anchor will use 'a' as a prefix.
     */

  }, {
    key: "createAlias",
    value: function createAlias(node, name) {
      if (!node.anchor) {
        var prev = anchorNames(this);
        node.anchor = // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        !name || prev.has(name) ? findNewAnchor(name || 'a', prev) : name;
      }

      return new Alias(node.anchor);
    }
  }, {
    key: "createNode",
    value: function createNode(value, replacer, options) {
      var _options2;

      var _replacer = undefined;

      if (typeof replacer === 'function') {
        value = replacer.call({
          '': value
        }, '', value);
        _replacer = replacer;
      } else if (Array.isArray(replacer)) {
        var keyToStr = function keyToStr(v) {
          return typeof v === 'number' || v instanceof String || v instanceof Number;
        };

        var asStr = replacer.filter(keyToStr).map(String);
        if (asStr.length > 0) replacer = replacer.concat(asStr);
        _replacer = replacer;
      } else if (options === undefined && replacer) {
        options = replacer;
        replacer = undefined;
      }

      var _ref = (_options2 = options) !== null && _options2 !== void 0 ? _options2 : {},
          aliasDuplicateObjects = _ref.aliasDuplicateObjects,
          anchorPrefix = _ref.anchorPrefix,
          flow = _ref.flow,
          keepUndefined = _ref.keepUndefined,
          onTagObj = _ref.onTagObj,
          tag = _ref.tag;

      var _createNodeAnchors = createNodeAnchors(this, // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      anchorPrefix || 'a'),
          onAnchor = _createNodeAnchors.onAnchor,
          setAnchors = _createNodeAnchors.setAnchors,
          sourceObjects = _createNodeAnchors.sourceObjects;

      var ctx = {
        aliasDuplicateObjects: aliasDuplicateObjects !== null && aliasDuplicateObjects !== void 0 ? aliasDuplicateObjects : true,
        keepUndefined: keepUndefined !== null && keepUndefined !== void 0 ? keepUndefined : false,
        onAnchor: onAnchor,
        onTagObj: onTagObj,
        replacer: _replacer,
        schema: this.schema,
        sourceObjects: sourceObjects
      };

      var node = _createNode(value, tag, ctx);

      if (flow && isCollection(node)) node.flow = true;
      setAnchors();
      return node;
    }
    /**
     * Convert a key and a value into a `Pair` using the current schema,
     * recursively wrapping all values as `Scalar` or `Collection` nodes.
     */

  }, {
    key: "createPair",
    value: function createPair(key, value) {
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var k = this.createNode(key, null, options);
      var v = this.createNode(value, null, options);
      return new Pair(k, v);
    }
    /**
     * Removes a value from the document.
     * @returns `true` if the item was found and removed.
     */

  }, {
    key: "delete",
    value: function _delete(key) {
      return assertCollection(this.contents) ? this.contents.delete(key) : false;
    }
    /**
     * Removes a value from the document.
     * @returns `true` if the item was found and removed.
     */

  }, {
    key: "deleteIn",
    value: function deleteIn(path) {
      if (isEmptyPath(path)) {
        if (this.contents == null) return false; // @ts-expect-error Presumed impossible if Strict extends false

        this.contents = null;
        return true;
      }

      return assertCollection(this.contents) ? this.contents.deleteIn(path) : false;
    }
    /**
     * Returns item at `key`, or `undefined` if not found. By default unwraps
     * scalar values from their surrounding node; to disable set `keepScalar` to
     * `true` (collections are always returned intact).
     */

  }, {
    key: "get",
    value: function get(key, keepScalar) {
      return isCollection(this.contents) ? this.contents.get(key, keepScalar) : undefined;
    }
    /**
     * Returns item at `path`, or `undefined` if not found. By default unwraps
     * scalar values from their surrounding node; to disable set `keepScalar` to
     * `true` (collections are always returned intact).
     */

  }, {
    key: "getIn",
    value: function getIn(path, keepScalar) {
      if (isEmptyPath(path)) return !keepScalar && isScalar(this.contents) ? this.contents.value : this.contents;
      return isCollection(this.contents) ? this.contents.getIn(path, keepScalar) : undefined;
    }
    /**
     * Checks if the document includes a value with the key `key`.
     */

  }, {
    key: "has",
    value: function has(key) {
      return isCollection(this.contents) ? this.contents.has(key) : false;
    }
    /**
     * Checks if the document includes a value at `path`.
     */

  }, {
    key: "hasIn",
    value: function hasIn(path) {
      if (isEmptyPath(path)) return this.contents !== undefined;
      return isCollection(this.contents) ? this.contents.hasIn(path) : false;
    }
    /**
     * Sets a value in this document. For `!!set`, `value` needs to be a
     * boolean to add/remove the item from the set.
     */

  }, {
    key: "set",
    value: function set(key, value) {
      if (this.contents == null) {
        // @ts-expect-error We can't really know that this matches Contents.
        this.contents = collectionFromPath(this.schema, [key], value);
      } else if (assertCollection(this.contents)) {
        this.contents.set(key, value);
      }
    }
    /**
     * Sets a value in this document. For `!!set`, `value` needs to be a
     * boolean to add/remove the item from the set.
     */

  }, {
    key: "setIn",
    value: function setIn(path, value) {
      if (isEmptyPath(path)) {
        // @ts-expect-error We can't really know that this matches Contents.
        this.contents = value;
      } else if (this.contents == null) {
        // @ts-expect-error We can't really know that this matches Contents.
        this.contents = collectionFromPath(this.schema, Array.from(path), value);
      } else if (assertCollection(this.contents)) {
        this.contents.setIn(path, value);
      }
    }
    /**
     * Change the YAML version and schema used by the document.
     * A `null` version disables support for directives, explicit tags, anchors, and aliases.
     * It also requires the `schema` option to be given as a `Schema` instance value.
     *
     * Overrides all previously set schema options.
     */

  }, {
    key: "setSchema",
    value: function setSchema(version) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      if (typeof version === 'number') version = String(version);
      var opt;

      switch (version) {
        case '1.1':
          if (this.directives) this.directives.yaml.version = '1.1';else this.directives = new Directives({
            version: '1.1'
          });
          opt = {
            resolveKnownTags: false,
            schema: 'yaml-1.1'
          };
          break;

        case '1.2':
        case 'next':
          if (this.directives) this.directives.yaml.version = version;else this.directives = new Directives({
            version: version
          });
          opt = {
            resolveKnownTags: true,
            schema: 'core'
          };
          break;

        case null:
          if (this.directives) delete this.directives;
          opt = null;
          break;

        default:
          {
            var sv = JSON.stringify(version);
            throw new Error("Expected '1.1', '1.2' or null as first argument, but found: ".concat(sv));
          }
      } // Not using `instanceof Schema` to allow for duck typing


      if (options.schema instanceof Object) this.schema = options.schema;else if (opt) this.schema = new Schema(Object.assign(opt, options));else throw new Error("With a null YAML version, the { schema: Schema } option is required");
    } // json & jsonArg are only used from toJSON()

  }, {
    key: "toJS",
    value: function toJS() {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          json = _ref2.json,
          jsonArg = _ref2.jsonArg,
          mapAsMap = _ref2.mapAsMap,
          maxAliasCount = _ref2.maxAliasCount,
          onAnchor = _ref2.onAnchor,
          reviver = _ref2.reviver;

      var ctx = {
        anchors: new Map(),
        doc: this,
        keep: !json,
        mapAsMap: mapAsMap === true,
        mapKeyWarned: false,
        maxAliasCount: typeof maxAliasCount === 'number' ? maxAliasCount : 100
      };

      var res = _toJS(this.contents, jsonArg !== null && jsonArg !== void 0 ? jsonArg : '', ctx);

      if (typeof onAnchor === 'function') {
        var _iterator = _createForOfIteratorHelper(ctx.anchors.values()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _ref4 = _step.value;
            var count = _ref4.count;
            var _res = _ref4.res;
            onAnchor(_res, count);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }

      return typeof reviver === 'function' ? applyReviver(reviver, {
        '': res
      }, '', res) : res;
    }
    /**
     * A JSON representation of the document `contents`.
     *
     * @param jsonArg Used by `JSON.stringify` to indicate the array index or
     *   property name.
     */

  }, {
    key: "toJSON",
    value: function toJSON(jsonArg, onAnchor) {
      return this.toJS({
        json: true,
        jsonArg: jsonArg,
        mapAsMap: false,
        onAnchor: onAnchor
      });
    }
    /** A YAML representation of the document. */

  }, {
    key: "toString",
    value: function toString() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (this.errors.length > 0) throw new Error('Document with errors cannot be stringified');

      if ('indent' in options && (!Number.isInteger(options.indent) || Number(options.indent) <= 0)) {
        var s = JSON.stringify(options.indent);
        throw new Error("\"indent\" option must be a positive integer, not ".concat(s));
      }

      return stringifyDocument(this, options);
    }
  }]);

  return Document;
}();

function assertCollection(contents) {
  if (isCollection(contents)) return true;
  throw new Error('Expected a YAML collection as document contents');
}

export { Document };